export default __webpack_public_path__ + "static/media/logo.8ae157f0.png";